<app-password-meter-progress-bar [value]="passwordStrengthResult.result"
                                 [color]="passwordStrengthResult.color">
</app-password-meter-progress-bar>
<ng-container *ngIf="displayMessages">
  <div class="error-message"
       *ngFor="let message of passwordStrengthResult.messages">{{message}}</div>
</ng-container>
